import type { ReviewInboxSource } from "./review-inbox";
import { rpc } from "./rpc";

/**
 * Review inbox against the server: reviews.* over oRPC (RAK-425), questions through threads.send
 * into the card's thread (session or main chat). Errors keep their oRPC code (CONFLICT,
 * NOT_FOUND, BAD_REQUEST) for isReviewGone and the page.
 */
export function createRpcReviewSource(): ReviewInboxSource {
  return {
    list: () => rpc.reviews.list({}),
    answer: (id, input) => rpc.reviews.answer({ id, ...input }),
    defer: (id) => rpc.reviews.defer({ id }),
    reopen: (id) => rpc.reviews.reopen({ id }),
    reorder: (id, beforeId) => rpc.reviews.reorder(beforeId ? { id, beforeId } : { id }),
    count: async () => (await rpc.reviews.count()).open,
    async ask(item, text) {
      await rpc.threads.send({
        botId: item.botId,
        ...(item.sessionId ? { sessionId: item.sessionId } : {}),
        text,
        clientNonce: crypto.randomUUID(),
      });
    },
  };
}
